import { RecheckIcon } from '@chegg-ui/theme'
import styled, { css } from 'styled-components'

export const recheckPositions = {
  giant: css`
    left: 100px;
    bottom: 0;
  `,
  desktop: css`
    top: ${props => props.theme.spacing.md};
    right: 0;
  `,
}

export const gatePositions = {
  giant: css`
    bottom: 30px;
  `,
  desktop: css`
    top: 40px;
  `,
}

export const StyledRecheckIcon = styled(RecheckIcon)`
  height: 28px;
  width: 28px;
  margin-right: -2px;
`



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/styles.tsx